import {
  GenericApiService,
  IListApiResponse,
  ISingleApiResponse,
} from "src/api/API_GenericService";
import { MaintenanceEndpoints } from "src/constants/apiEndpoints";
import { ISpecialAccessUser } from "src/models/Maintenance/SpecialAccessUser.models";
import { PaginationParams } from "src/shared/models/PaginationParams.models";
import { setSpecialAccessUsernames } from "src/store/Authentication/specialAccessSlice";
import {
  setSpecialAccessUserList,
  addSpecialAccessUser,
  updateSpecialAccessUser,
  deleteSpecialAccessUser,
  setSpecialAccessUserToEdit,
  concatListSpecialAccessUser,
} from "src/store/Maintenance/slices/specialAccessUserSlice";

const ApiService = new GenericApiService<ISpecialAccessUser>();
const ActiveUsernamesApiService = new GenericApiService<string>();

const LoadActiveSpecialAccessUsernames = (dispatch: any) => {
  return new Promise<IListApiResponse<string>>(async (resolve, reject) => {
    try {
      const response = await ActiveUsernamesApiService.getAllByRoute(
        MaintenanceEndpoints.specialAccessUser,
        "getActiveUsernames"
      );
      dispatch(
        setSpecialAccessUsernames(response?.success ? response?.data ?? [] : [])
      );
      resolve(response);
    } catch (exception) {
      dispatch(setSpecialAccessUsernames([]));
      reject(exception);
    }
  });
};

const GetAllSpecialAccessUserList = (
  dispatch: any,
  pagination?: PaginationParams
) => {
  return new Promise<IListApiResponse<ISpecialAccessUser>>(
    async (resolve, reject) => {
      try {
        const response = await ApiService.getAll(
          MaintenanceEndpoints.specialAccessUser,
          pagination?.params
        );
        if (response?.success) {
          if (pagination?.concat) {
            dispatch(concatListSpecialAccessUser(response?.data));
          } else {
            dispatch(setSpecialAccessUserList(response?.data));
          }
        }
        resolve(response);
      } catch (exception) {
        reject(exception);
      }
    }
  );
};

const GetSpecialAccessUserById = (dispatch: any, id: number) => {
  return new Promise<ISingleApiResponse<ISpecialAccessUser>>(
    async (resolve, reject) => {
      try {
        const response = await ApiService.getById(
          MaintenanceEndpoints.specialAccessUser,
          id
        );
        if (response?.success) {
          dispatch(setSpecialAccessUserToEdit(response?.data));
        }
        resolve(response);
      } catch (exception) {
        reject(exception);
      }
    }
  );
};

const AddNewSpecialAccessUser = (dispatch: any, newItem: ISpecialAccessUser) => {
  return new Promise<ISingleApiResponse<ISpecialAccessUser>>(
    async (resolve, reject) => {
      try {
        const response = await ApiService.create(
          MaintenanceEndpoints.specialAccessUser,
          newItem
        );
        if (response.success) {
          dispatch(addSpecialAccessUser(response?.data));
          await LoadActiveSpecialAccessUsernames(dispatch);
        }
        resolve(response);
      } catch (exception) {
        reject(exception);
      }
    }
  );
};

const UpdateSpecialAccessUserOnList = (
  dispatch: any,
  newItem: ISpecialAccessUser
) => {
  return new Promise<ISingleApiResponse<ISpecialAccessUser>>(
    async (resolve, reject) => {
      try {
        const response = await ApiService.update(
          MaintenanceEndpoints.specialAccessUser,
          newItem
        );
        if (response.success) {
          dispatch(updateSpecialAccessUser(response?.data));
          await LoadActiveSpecialAccessUsernames(dispatch);
        }
        resolve(response);
      } catch (exception) {
        reject(exception);
      }
    }
  );
};

const DeleteSpecialAccessUser = (dispatch: any, newItem: ISpecialAccessUser) => {
  return new Promise<ISingleApiResponse<ISpecialAccessUser>>(
    async (resolve, reject) => {
      try {
        const response = await ApiService.deleteById(
          MaintenanceEndpoints.specialAccessUser,
          newItem.specialAccessUserId
        );
        if (response.success) {
          dispatch(deleteSpecialAccessUser(newItem.specialAccessUserId));
          await LoadActiveSpecialAccessUsernames(dispatch);
        }
        resolve(response);
      } catch (exception) {
        reject(exception);
      }
    }
  );
};

export {
  LoadActiveSpecialAccessUsernames,
  GetSpecialAccessUserById,
  GetAllSpecialAccessUserList,
  AddNewSpecialAccessUser,
  UpdateSpecialAccessUserOnList,
  DeleteSpecialAccessUser,
};
